import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'emit-data',
    templateUrl: '../../templates/partials/emitData-bill.html'
})

export class EmitDataBillComponent implements OnInit {

    @Input() emitData;
    constructor(private router: Router) { }

    public goToCleaner(id: string) {
        this.router.navigate(['/cleaners', id]);
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/emitData-bill.component.ts